const serviceName = '/service/msg-artifact'
export default serviceName
